import Highlights from '@/vdp/VehicleInfo/Highlights';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import BasicInfo from './BasicInfo';
import GetYourTerms from './GetYourTerms';
import Price from './Price';
import ShippingAndGetItBy from './ShippingAndGetItBy';
import Terms from './Terms';
import { VehicleInfoProvider } from './VehicleInfoContext';

type OwnProps = {
  enablePriceObserver?: boolean;
  isCondensed?: boolean;
};

export function VehicleInfo() {
  const isDealership = useIsDealershipPage();

  return (
    <div className="flex w-full flex-col gap-xl sm:gap-2xl">
      <BasicInfo />
      <div className="flex flex-col gap-xl">
        <div className="grid justify-items-start gap-md md:gap-xl">
          <div className="w-full">
            <div className="flex w-full items-end justify-between gap-x-xl">
              <Price />
              <GetYourTerms />
            </div>
            <Highlights />
          </div>
          <Terms />
        </div>
        {!isDealership && <ShippingAndGetItBy />}
      </div>
    </div>
  );
}

export default function VehicleInfoWrapper(props: OwnProps) {
  return (
    <VehicleInfoProvider value={props}>
      <VehicleInfo />
    </VehicleInfoProvider>
  );
}
